export interface GiftBenefit {
  title: string;
  subtitle?: string;
}

export const MainPlanPromo = {
  enabled: false,
  code: 'VIP40',
  discount: 40,
};

export const GIFT_CAMPAIGN = {
  enabled: false,
  code: 'GWP_2026_05',
  timerMinutes: 15,
  eligibleIntervalMonths: [3, 6] as readonly number[],
  eligibleCountries: ['AU', 'AUSTRALIA'] as readonly string[],
  copy: {
    nudgeTemplate: 'Select {{plans}} and unlock a free gift \u{1F381}',
    cardBadge: 'Free Gift Unlocked',
    cardTitle: 'Sign Up Today & Get A Free Protein Powder',
    benefits: [
      {
        title: '1 x Whey Protein Powder 500g',
        subtitle: 'Flavour of your choice (valued at $59)',
      },
      { title: 'Free postage Australia-wide' },
    ] as readonly GiftBenefit[],
    eligibilityNoteTemplate: 'Only available on the {{plans}} Subscription',
    bannerLabel: 'Early bird exclusive pricing',
    bannerExpiredLabel: 'Free gift offer has expired',
  },
} as const;

export const GIFT_TIMER_STORAGE_KEY = 'equ.gift.expiresAt';
export const SIX_MONTH_CAMPAIGN_TIMER_KEY = 'equ.gift.6month.expiresAt';
